import React from "react";

import type { IconProp } from "@fortawesome/fontawesome-svg-core";

import Button, { LabelIconForButton } from "~/ui/button";

import styles from "./EmptyState.module.css";

export const EmptyState = ({
	title,
	description,
	buttonText,
	buttonOnClick,
	buttonIcon,
}: {
	title: string;
	description: string;
	buttonText?: string;
	buttonOnClick?: () => void;
	buttonIcon?: IconProp;
}) => {
	return (
		<div className={styles.emptyState}>
			<h2 className={styles.emptyStateTitle}>{title}</h2>
			<p className={styles.emptyStateDescription}>{description}</p>
			{buttonText && buttonOnClick && (
				<Button size="slim" variant="secondary" className={styles.emptyStateButton} onClick={buttonOnClick}>
					{buttonIcon && <LabelIconForButton icon={buttonIcon} side="left" />}
					{buttonText}
				</Button>
			)}
		</div>
	);
};
